<template>
  <div>
    <div class="displaybotwrap">
      <a @click="displaybot" class="displaybot">
        <!-- <i class="material-icons dp48">chat_bubble</i> -->
        <svg
          aria-labelledby="simpleicons-allo-icon"
          role="img"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title id="simpleicons-allo-icon"></title>
          <path
            d="M11.665.005c-.702.018-1.417.098-2.14.243C4.788 1.193 1.08 4.974.21 9.728c-1.36 7.406 4.096 14.256 11.16 14.256L22.227 24c.98 0 1.774-.793 1.774-1.774V12C24 5.26 18.445-.18 11.665.005zM12 6.135c3.238 0 5.862 2.626 5.862 5.865v5.61c0 .245-.293.367-.467.194l-1.46-1.46c-1.04.944-2.42 1.52-3.936 1.52-3.24 0-5.865-2.626-5.865-5.864 0-3.24 2.627-5.865 5.865-5.865z"
          ></path>
        </svg>
      </a>
    </div>
    <lex-web-ui
      ref="lexweb"
      v-bind:class="showUI === true ? ' ' : 'noUI'"
      v-on:updateLexState="onUpdateLexState"
      localConfig="localConfig"
    ></lex-web-ui>
  </div>
</template>


<script>
/*eslint-disable */
import Vue from 'vue'
import Logger from '../components/loger'
import Vuetify from 'vuetify'
import Vuex from 'vuex'
import AWS from 'aws-sdk'
import { Config as AWSConfig, CognitoIdentityCredentials } from 'aws-sdk'
import LexRuntime from 'aws-sdk/clients/lexruntime'
import Polly from 'aws-sdk/clients/polly'
import { Plugin as LexWebUi, Store as LexWebUiStore } from 'aws-lex-web-ui'
Vue.use(Vuex)
Vue.use(Vuetify)
import $ from 'jquery'
var jQuery = $
const poolId = 'eu-west-1:b77632ec-1699-48f7-a294-98db07aa0b64'
const region = 'eu-west-1'
const idtoken = window.localStorage.getItem('jwtToken')
const poolName = window.localStorage.getItem('poolname')
const noauth = window.localStorage.getItem('noauth')

// const poolId = 'eu-west-1:b77632ec-1699-48f7-a294-98db07aa0b64'
let credentials
var logins = {}
// logins[poolName] = idtoken
if (noauth === 'true') {
  credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: poolId
  }, { region })
} else {
  credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: poolId,
    Logins: logins
  }, { region })
}
const httpOptions = {
  timeout: 320000
}
const localConfig = new AWS.Config({ region, credentials, httpOptions })
const store = new Vuex.Store(LexWebUiStore)
const lexRuntimeClient = new LexRuntime(localConfig)
const pollyClient = new Polly(localConfig)
var inintext = 'Hi, This is Cassie!! \n How can I help you?'
// see the configuration section for details about the config fields
var ENV_name = window.localStorage.getItem('ENV')
if (ENV_name === null || ENV_name === undefined) {
  getApptype()
  ENV_name = window.localStorage.getItem('ENV')
}
function getApptype () {
  function getSubdomain (hostname) {
    var regexParse = new RegExp('[a-z-0-9]{2,63}[a-z.]{2,5}$')
    var urlParts = regexParse.exec(hostname)
    return hostname.replace(urlParts[0], '').slice(0, -1)
  }
  function getDomain (hostname) {
    var regexParse = new RegExp('[a-z-0-9]{2,63}[a-z.]{2,5}$')
    var urlParts = regexParse.exec(hostname)
    return urlParts[0]
  }
  var locationbr = getSubdomain(window.location.hostname)
  var domainname = getDomain(window.location.hostname)
  if ((domainname === 'd2dsuite.com' && locationbr === 'voyager') || (locationbr === 'd2d-da')) {
    window.localStorage.setItem('ENV', 'PROD')
  } else if (domainname === 'amazonaws.com' || domainname === 'localhost' || locationbr === 'coredev') {
    window.localStorage.setItem('ENV', 'DEV')
  } else if (locationbr === 'coreqa') {
    window.localStorage.setItem('ENV', 'QA')
  }
}
var sessionAttr = {
  'user_id': window.localStorage.getItem('username'),
  'job_id': window.localStorage.getItem('jobid')
}
const config = {
  cognito: {
    poolId: poolId
  },
  lex: {
    botName: 'VoyagerSandbox',
    initialText: inintext,
    botAlias: ENV_name,
    sessionAttributes: sessionAttr,
    'AllowSuperDangerousHTMLInMessage': false,
    'shouldDisplayResponseCardTitle': false,
    'pushInitialTextOnRestart': false,
    'initialSpeechInstruction': false,
    'lexState': { 'acceptFormat': 'text' },
    recorder: {
      "enable": false
    }
  },
  ui: {    toolbarLogo: '', toolbarTitle: ' ', textInputPlaceholder: 'Type here', recorder: {
      "enable": false
    }  },
  "polly": {
    enable: false,
    recorder: {
      "enable": false
    }
  },
  recorder: {
    "enable": false
  }
}

Vue.use(LexWebUi, { config, awsConfig: localConfig, lexRuntimeClient, pollyClient, store })

export default {
  name: 'Chat',
  components: {},
  props: ['awsconfig', 'showbot'],
  data () {
    return {
      localConfig: localConfig,
      showUI: false
    }
  },
  store: store,
  mounted () {
    logins = this.$parent.$store.state.Logins
    var eventtohanddle = this.$refs.lexweb.$children[0].$children[0].$children[0].$children[0].$el
    var self = this
    eventtohanddle.addEventListener('click', function (target) {
      // if (self.showUI === false) {
      //   self.showUI = true
      //   return
      // } else if (self.showUI === true) {
      //   self.showUI = false
      //   return
      // }
    })
  },
  updated () {
    // if (this.$refs.lexweb._isMounted) {
    var eventtohanddle = this.$refs.lexweb.$children[0].$children[0].$children[0].$children[0].$el
    var self = this
    eventtohanddle.addEventListener('click', function (target) {
      self.showUI = false
    })
    var scroll = this.$refs.lexweb.$children[0].$children[0].$children[1].$children[0].$el
    scroll.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' })
    // }
  },
  created: {},
  computed: {
    hideUI: {
      get: function (parms) {
        return parms.showbot
      },
      set: function (parms) {
        return parms.showbot
      }
    }
  },
  methods: {
    displaybot () {
      this.showUI = true
    },
    onUpdateLexState (lexState) {
      Logger.debug('handle update: ' + JSON.stringify(lexState, null, 2))
      var scroll = this.$refs.lexweb.$children[0].$children[0].$children[1].$children[0].$el
      scroll.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' })
      setTimeout(() => {
        scroll.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' })
      }, 500)
      if (lexState.dialogState === 'Fulfilled') {
        //
      }
    },
    trackchange (e, t) {
      console.log(e)
      console.log(t)
      var scroll = this.$refs.lexweb.$children[0].$children[0].$children[1].$children[0].$el
      scroll.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' })
    }
  }
}

</script>
<style scoped>
.container.message-list-container.fluid.pa-0 {
  height: 60vh;
  max-width: 30%;
}
@import '../../node_modules/roboto-fontface/css/roboto/roboto-fontface.css';
@import '../../node_modules/material-design-icons/iconfont/material-icons.css';
/* @import '../../node_modules/vuetify/dist/vuetify.min.css'; */
@import '/static/css/lex-web-ui.css';
</style>
<style scoped>
button.chat {
  position: absolute;
  width: 200px;
  z-index: 999999;
  top: 56px;
  right: 0px;
  background: blue;
  color: white;
}
.displaybotwrap {
  position: fixed;
  bottom: 100px;
  right: 15px;
}
a.displaybot svg {
  height: 50px;
  width: 50px;
  fill: #0caed6;
  filter: drop-shadow(2px 3px 3px rgba(0, 0, 0, 0.5));
}
a.displaybot {
  display: inline-block;
  width: auto;
  line-height: 0;
  padding: 0;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  font-size: 0px;
  content: ' ';
  border: none;
  border-right: none;
  border-radius: 10px 0px 0px 10px;
  background: #fff;
}

a.displaybot i {
  /* position: absolute; */
  /* right: 10px; */
  font-size: 50px;
  /* line-height: 40px; */
}

div#lex-web.noUI {
  width: 0px;
  height: 0px;
  border: none;
  overflow: hidden;
}
</style>
<style>
div#lex-web footer {
  position: absolute;
  bottom: 0px;
  min-height: 48px;
}
div#lex-web footer button {
  background: #444;
  outline: none;
}
div#lex-web footer button:focus,
div#lex-web footer button:active,
input:focus,
input:active {
  outline: none;
}
div#lex-web footer button.v-btn--disabled {
  background: gray;
}
div#lex-web footer button.v-btn--disabled i.v-icon {
  opacity: 0.2;
}
div#lex-web footer .v-btn__content i.v-icon {
  color: #fff;
}
.v-tooltip__content {
  display: none !important;
}
</style>




// WEBPACK FOOTER //
// Chat.vue?2a4fecf4